import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";
import { limitWords } from "@utils/limitWords";

const DEACTIVATEMESSAGE = gql`
   mutation updateMessage($id: ID!, $updateInput: UpdateMessageInput!){
    updateMessage(id: $id, updateInput: $updateInput)
  }
`;
function DeactivateMessage({ id, title, children, onDeactivateMessage }) {
    const [runDeactivateMessage, setDeactivateMessage] = useMutation(DEACTIVATEMESSAGE, {
        onCompleted({ updateMessage }) {
            message.success(` پیام ${title ? limitWords(title, 5) : ""} غیرفعال شد.`);
            onDeactivateMessage();
        },
        onError() {
            message.error("متاسفانه مشکلی پیش آمده!پیام غیرفعال نشد.");
        },
    });
    const doDeactivateMessage = () => {
        runDeactivateMessage({
            variables: { id, updateInput: { isActive: false } },
        });
    };
    return (
        <>
            <Popconfirm
                title={`غیرفعال کردن ${title ? "پیام " + limitWords(title, 5) : "پیام"}?`}
                okText="غیرفعال کردن"
                cancelText="خیر"
                onConfirm={doDeactivateMessage}
            >
                <span>{children}</span>
            </Popconfirm>
        </>
    );
}

export default DeactivateMessage;